<template>
  <el-drawer
    :class="['ui-drawer-wrapper', wrapperClass]"
    :visible="value"
    :append-to-body="appendToBody"
    :custom-class="resolvedCustomClass"
    v-bind="$attrs"
    v-on="forwardedListeners"
    @update:visible="updateVisible"
  >
    <slot />
    <template v-if="$slots.title || $scopedSlots.title || $attrs.title" slot="title">
      <slot name="title">
        <span class="ui-section-title" :class="{ 'has-icon': Boolean(icon) }">
          <i v-if="icon" :class="icon" aria-hidden="true"></i>{{ $t($attrs.title) }}</span>
      </slot>
    </template>
  </el-drawer>
</template>

<script>
export default {
  name: 'UiDrawer',
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    icon: { type: [String, Array, Object], default: '' },
    appendToBody: { type: Boolean, default: true },
    customClass: { type: String, default: '' },
    wrapperClass: { type: String, default: '' }
  },
  computed: {
    resolvedCustomClass () {
      return ['ui-drawer', this.customClass].filter(Boolean).join(' ')
    },
    forwardedListeners () {
      const listeners = { ...this.$listeners }
      delete listeners['update:visible']
      return listeners
    }
  },
  methods: {
    updateVisible (visible) {
      this.$emit('input', visible)
      this.$emit('update:visible', visible)
    }
  }
}
</script>
